import React from 'react';

interface RainbowHeartIconProps {
  size?: number;
  className?: string;
}

const RainbowHeartIcon: React.FC<RainbowHeartIconProps> = ({ size = 16, className = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <g clipPath="url(#paint0_angular_4741_418_clip_path)" data-figma-skip-parse="true">
        <g transform="matrix(-0.006 0 0 -0.00555764 8 8.02444)">
          <foreignObject x="-1179.93" y="-1179.93" width="2359.86" height="2359.86">
            <div 
              style={{
                background: 'conic-gradient(from 90deg,rgba(111, 246, 172, 1) 0deg,rgba(82, 133, 255, 1) 113.4deg,rgba(247, 91, 255, 1) 234deg,rgba(113, 255, 177, 1) 360deg)',
                height: '100%',
                width: '100%',
                opacity: 1
              }}
            />
          </foreignObject>
        </g>
      </g>
      
      <path 
        d="M7.99703 13.5821C8.0762 13.5821 8.16526 13.5583 8.26423 13.5108C8.36715 13.4633 8.46413 13.4099 8.55517 13.3505C9.66353 12.638 10.6235 11.8899 11.4349 11.1061C12.2504 10.3223 12.8817 9.51479 13.329 8.68352C13.7763 7.85225 14 7.01504 14 6.17189C14 5.62563 13.9109 5.12687 13.7328 4.6756C13.5586 4.22038 13.3172 3.8285 13.0084 3.49995C12.6997 3.1714 12.3394 2.91806 11.9278 2.73993C11.5161 2.55784 11.0727 2.4668 10.5977 2.4668C10.0079 2.4668 9.49332 2.61722 9.05393 2.91806C8.61851 3.21494 8.2662 3.60683 7.99703 4.09371C7.73577 3.61079 7.38545 3.2189 6.94607 2.91806C6.50668 2.61722 5.99208 2.4668 5.40228 2.4668C4.92726 2.4668 4.48392 2.55784 4.07224 2.73993C3.66452 2.91806 3.3043 3.1714 2.99159 3.49995C2.68283 3.8285 2.43939 4.22038 2.26126 4.6756C2.08709 5.12687 2 5.62563 2 6.17189C2 7.01504 2.22167 7.85225 2.66502 8.68352C3.11232 9.51479 3.74369 10.3223 4.55913 11.1061C5.37853 11.8899 6.3424 12.638 7.45077 13.3505C7.53785 13.4099 7.63285 13.4633 7.73577 13.5108C7.83869 13.5583 7.92578 13.5821 7.99703 13.5821Z" 
        fill="url(#paint1_radial_4741_418)"
      />
      
      <defs>
        <clipPath id="paint0_angular_4741_418_clip_path">
          <path d="M7.99703 13.5821C8.0762 13.5821 8.16526 13.5583 8.26423 13.5108C8.36715 13.4633 8.46413 13.4099 8.55517 13.3505C9.66353 12.638 10.6235 11.8899 11.4349 11.1061C12.2504 10.3223 12.8817 9.51479 13.329 8.68352C13.7763 7.85225 14 7.01504 14 6.17189C14 5.62563 13.9109 5.12687 13.7328 4.6756C13.5586 4.22038 13.3172 3.8285 13.0084 3.49995C12.6997 3.1714 12.3394 2.91806 11.9278 2.73993C11.5161 2.55784 11.0727 2.4668 10.5977 2.4668C10.0079 2.4668 9.49332 2.61722 9.05393 2.91806C8.61851 3.21494 8.2662 3.60683 7.99703 4.09371C7.73577 3.61079 7.38545 3.2189 6.94607 2.91806C6.50668 2.61722 5.99208 2.4668 5.40228 2.4668C4.92726 2.4668 4.48392 2.55784 4.07224 2.73993C3.66452 2.91806 3.3043 3.1714 2.99159 3.49995C2.68283 3.8285 2.43939 4.22038 2.26126 4.6756C2.08709 5.12687 2 5.62563 2 6.17189C2 7.01504 2.22167 7.85225 2.66502 8.68352C3.11232 9.51479 3.74369 10.3223 4.55913 11.1061C5.37853 11.8899 6.3424 12.638 7.45077 13.3505C7.53785 13.4099 7.63285 13.4633 7.73577 13.5108C7.83869 13.5583 7.92578 13.5821 7.99703 13.5821Z"/>
        </clipPath>
        
        <radialGradient 
          id="paint1_radial_4741_418"
          cx="0" 
          cy="0" 
          r="1" 
          gradientUnits="userSpaceOnUse" 
          gradientTransform="translate(8 8.02444) rotate(137.163) scale(8.18225 6.91119)"
        >
          <stop stopColor="white"/>
          <stop offset="1" stopColor="white" stopOpacity="0"/>
        </radialGradient>
      </defs>
    </svg>
  );
};

export default RainbowHeartIcon;
